import { useState as i, useRef as f } from "react";
import { Pool as d } from "./index130.mjs";
import { useDeepEffect as c } from "./index131.mjs";
function k(n, r) {
  self.onmessage = async (s) => {
    try {
      const a = n(s.data);
      if (a && a[Symbol.asyncIterator])
        for await (const o of a) self.postMessage(o, r == null ? void 0 : r());
      else if (a && a[Symbol.iterator])
        for (const o of a) self.postMessage(o, r == null ? void 0 : r());
      else
        self.postMessage(await a, r == null ? void 0 : r());
    } catch (a) {
      self.postMessage({ error: a.toString() }, r == null ? void 0 : r());
    }
  };
}
const u = {
  loading: !0
};
function M(n, r, s = [r]) {
  const [a, o] = i(u), e = f(null);
  return c(() => {
    window.Pool = window.Pool || new d(8), e.current || window.Pool.addWorker({
      createWorker: n,
      onWorkerInitialized: (l) => {
        e && (o(u), e.current = l, e.current.worker.postMessage(r));
      },
      onMessage: (l) => o({ result: l.data, loading: !1 }),
      onError: (l) => o({ error: "error", loading: !1 }),
      onMessageError: (l) => o({ error: "messageerror", loading: !1 }),
      onFinish: () => {
        e.current = null;
      }
    });
  }, [...s]), [a, o];
}
function P(n) {
  const r = f(null);
  return async (s) => (window.Pool = window.Pool || new d(8), r.current !== null && (window.Pool.removeFromQueue(r.current.id), r.current = null), new Promise((a, o) => {
    r.current = window.Pool.addWorker({
      createWorker: n,
      onWorkerInitialized: (e) => {
        if (!e) return o();
        e.worker.postMessage(s);
      },
      onMessage: (e) => {
        e.data.error && o(e.data.error), a(e.data);
      },
      onError: (e) => o(e.error),
      onMessageError: (e) => o(e.data),
      onFinish: () => {
        r.current = null;
      }
    });
  }));
}
export {
  k as exposeWorker,
  P as useAsyncWorker,
  M as useWorker
};
